




















































import {Component, Mixins} from 'vue-mixin-decorator';

import Widget from '@/components/Utils/Widget.vue';

import {BaseComponent} from '@/mixins/BaseComponent';
import {EventBus} from '@/utils/EventBus';

@Component({
  components: {Widget},
})
export default class SystemChangesWidget extends Mixins<BaseComponent>(BaseComponent) {

  private async openPage(name: string) {
    await this.$router.push({
      name: name,
    });
  }
}
